import React, { useState, useEffect } from "react";
import styled from "styled-components";

// Imported assets
import {
  LeftCaretIcon,
  RightCaretIcon,
} from "../../../../assets/icons/svgs/Icons";
import hybridIcon from "../../../../assets/icons/GoogleMaps_HybridView.svg";
import roadmapIcon from "../../../../assets/icons/GoogleMaps_DefaultView.svg";
import satelliteIcon from "../../../../assets/icons/GoogleMaps_SatelliteView.svg";
import terrainIcon from "../../../../assets/icons/GoogleMaps_TerrainView.svg";

// Styled components
const Button = styled.button`
  align-items: center;
  color: black;
  cursor: pointer;
  display: flex;
  font-size: 12px;
  height: 60px;
  justify-content: center;
  margin: 10px 5px 10px 0px;
  width: 60px;

  &:hover {
    filter: brightness(105%);
  }
`;

interface ContainerProps {
  $isMinimized?: boolean;
}

const Container = styled.div<ContainerProps>`
  background: lab(from #39656F l a b / 0.5);
  // border: 1px solid #D9D9D9;
  border-radius: 0px 8px 8px 0px;
  display: flex;
  flex-direction: column;
  height: 400px;
  justify-content: center; // Center items vertically
  left: ${({ $isMinimized }) => ($isMinimized ? "-72px" : "0px")};
  padding: 10px 24px 10px 10px;
  position: absolute;
  transition: left 0.3s ease; // Add transition for smooth animation
  z-index: 100;
`;

const Icon = styled.img`
  height: auto;
  width: 10px;
`;

interface ImgProps {
  $isSelected?: boolean;
}

const Img = styled.img<ImgProps>`
  outline: ${({ $isSelected }) =>
    $isSelected ? "2px solid var(--terbine-blue)" : "none"};
  border-radius: 16px;
`;

const Label = styled.span`
  color: white;
  font-size: 12px;
  margin-top: 75px;
  position: absolute;
`;

const MinimizeButtonContainer = styled.button`
  background-color: rgba(255, 255, 255, 0);
  border: none;
  color: black;
  cursor: pointer;
  padding: 0px;
  position: absolute;
  right: 0;
  top: 50%; // Position it halfway vertically
  transform: translateY(-50%); // Center it vertically
  z-index: 101;
`;

const MapStyleControls = (props) => {
  const [isMinimized, setIsMinimized] = useState<boolean>(false);
  const [selectedMapType, setSelectedMapType] = useState(props.defaultStyle);

  // toggle the minimized state
  const toggleMinimize = () => {
    setIsMinimized(!isMinimized);
  };

  // set the selected map type and call the parent function
  // we need to track the selected one for highlighting
  const handleMapTypeChange = (type) => {
    setSelectedMapType(type);
    props.handleMapTypeChange(type);
  };

  // set the default map type from the parent component
  useEffect(() => {
    setSelectedMapType(props.defaultStyle);
  }, [props.defaultStyle]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "center",
      }}
    >
      <Container $isMinimized={isMinimized}>
        <MinimizeButtonContainer onClick={toggleMinimize} type="button">
          {isMinimized ? (
            <RightCaretIcon fill="white" width="12px" />
          ) : (
            <LeftCaretIcon fill="white" width="12px" />
          )}
        </MinimizeButtonContainer>
        <Button>
          <Img
            src={roadmapIcon}
            onClick={() => handleMapTypeChange("roadmap")}
            alt="Roadmap"
            $isSelected={selectedMapType === "roadmap"}
          />
          <Label>Roadmap</Label>
        </Button>
        <Button>
          <Img
            src={terrainIcon}
            onClick={() => handleMapTypeChange("terrain")}
            alt="Terrain"
            $isSelected={selectedMapType === "terrain"}
          />
          <Label>Terrain</Label>
        </Button>
        <Button>
          <Img
            src={hybridIcon}
            onClick={() => handleMapTypeChange("hybrid")}
            alt="Hybrid"
            $isSelected={selectedMapType === "hybrid"}
          />
          <Label>Hybrid</Label>
        </Button>
        <Button>
          <Img
            src={satelliteIcon}
            onClick={() => handleMapTypeChange("satellite")}
            alt="Satellite"
            $isSelected={selectedMapType === "satellite"}
          />
          <Label>Satellite</Label>
        </Button>
      </Container>
    </div>
  );
};

export default MapStyleControls;
